export const ANALYTICS_ENDPOINTS = {
    LIVE_CALLS: `/analytics/live-calls`,
    AVERAGE_HANDLING_TIME: `/analytics/average-handling-time`,
    VOLUME_TRENDS: `/analytics/volume-trends`,
    CALL_ENDINGS: `/analytics/call-endings`,
} as const;

